import { mapActions, mapGetters, mapMutations } from 'vuex'

import courseAccessService from '@/services/courseAccessService'
import CourseStructureTree from './CourseStructureTree.vue'

export default {
	name		: 'BulkAccessModal',
	components	: {
		CourseStructureTree
	},
	props		: {
		value		: {
			type		: Boolean,
			required	: true
		},
		packageId	: {
			type		: Number,
			required	: true
		},
		packageName	: {
			type		: String,
			required	: true
		},
		courseId	: {
			type		: Number,
			required	: true
		}
	},
	data() {
		return {
			inited				: false,
			loading				: false,
			saving				: false,
			error				: null,
			search				: '',
			courseStructure		: null,
			selectedMaterials	: [], // Array of material IDs
			initialAccess		: [], // For tracking changes
			confirmCloseDialog	: false
		}
	},
	computed	: {
		...mapGetters({
			materialsContent		: 'coursesMaterials/materialsContent',
			materialsLoading		: 'coursesMaterials/materialsLoading',
			materialsUpdateContent	: 'coursesMaterials/materialsUpdateContent',
			updateMaterialsLoading	: 'coursesMaterials/updateMaterialsLoading'
		}),
		dialog: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			}
		},
		selectedCount() {
			return this.selectedMaterials.length
		},
		hasChanges() {
			// Compare current selection with initial
			if (this.selectedMaterials.length !== this.initialAccess.length) {
				return true
			}
			
			// Check if arrays are equal (order doesn't matter)
			const sorted1 = [...this.selectedMaterials].sort();
			const sorted2 = [...this.initialAccess].sort();
			
			return !sorted1.every((id, index) => id === sorted2[index])
		}
	},
	watch		: {
		dialog(val) {
			console.log('dialog:', val)
			console.log('packageId2:', this.packageId)
			
			if (val) {
				this.loadData()
			} else {
				this.reset()
			}
		},
		inited(){
			console.log('inited:', this.inited)
			console.log('packageId:', this.packageId)
			
			if(this.inited){
				this.loadData()
			}
		}
	},
	created () {
		console.log('BulkAccessModal created')
	},
	mounted () {
		console.log('BulkAccessModal mounted')
		
		this.$nextTick(() => {
			this.inited = true
			
			console.log('inited')
		})
	},
	methods		: {
		...mapActions({
			updateMaterials		: 'coursesMaterials/MATERIALS_UPDATE',
			fetchMaterials		: 'coursesMaterials/MATERIALS_GET'
		}),
		...mapMutations({
			//setCountryIds		: 'profile/SET_COUNTRY_IDS'
		}),
		async loadData() {
			await this.fetchMaterials({
				courseId	: this.courseId,
				packageId	: this.packageId
			})
			
			console.log('materialsContent:', this.materialsContent)
			
			this.preselectAccess();
			
			console.log('selected:', this.selectedMaterials)
		},
		preselectAccess() {
			// Pre-select materials that currently have access
			const selected = []
			
			this.materialsContent.modules.forEach(module => {
				if (module.hasAccess) {
					selected.push('module-'+module.id)
				}
				
				module.lessons.forEach(lesson => {
					lesson.materials.forEach(material => {
						if (material.hasAccess) {
							selected.push('materials-'+material.id)
						}
					})
					
					lesson.homeworks.forEach(hw => {
						if (hw.hasAccess) {
							selected.push('hw-'+hw.id)
						}
					})
				})
			})
			
			this.selectedMaterials = selected
			this.initialAccess = [...selected] // Copy for change detection
			
			console.log('📊 Pre-selected materials:', selected.length)
		},
		selectAll() {
			this.materialsContent.modules.forEach(module => {
				module.hasAccess = true;
				
				module.lessons.forEach(lesson => {
					lesson.materials.forEach(material => {
						material.hasAccess = true;
					})
					
					lesson.homeworks.forEach(hw => {
						hw.hasAccess = true;
					})
				})
			});
			
			this.preselectAccess();
		},
		deselectAll() {
			this.materialsContent.modules.forEach(module => {
				module.hasAccess = false;
				
				module.lessons.forEach(lesson => {
					lesson.materials.forEach(material => {
						material.hasAccess = false;
					})
					
					lesson.homeworks.forEach(hw => {
						hw.hasAccess = false;
					})
				})
			});
			
			this.preselectAccess();
		},
		async save() {
			this.saving = true
			
			try {
				console.log('selectedMaterials:')
				console.log(this.selectedMaterials)
				console.log('')
				
				await this.updateMaterials({
					courseId	: this.courseId,
					packageId	: this.packageId,
					data		: this.selectedMaterials
				})
				
				const message = this.$t('accessUpdatedSuccess') ||
				`Доступ оновлено для ${this.selectedMaterials.length} матеріалів`
				
				if (this.$toasted) {
					this.$toasted.success(message)
				}
				
				this.$emit('updated')
				this.forceClose()
			} catch (error) {
				console.error('Error saving access:', error)
				
				const message = error.message ||
				this.$t('failedToSaveAccess') ||
				'Не вдалося зберегти доступ'
				
				if (this.$toasted) {
					this.$toasted.error(message)
				}
			} finally {
				this.saving = false
			}
		},
		handleClose() {
			if (this.hasChanges && !this.saving) {
				this.confirmCloseDialog = true
			} else {
				this.forceClose()
			}
		},
		forceClose() {
			this.confirmCloseDialog = false
			this.dialog = false
		},
		reset() {
			this.courseStructure = null
			this.selectedMaterials = []
			this.initialAccess = []
			this.error = null
			this.search = ''
			this.confirmCloseDialog = false
			this.inited = false
		}
	},
	beforeDestroy () {
		console.log('beforeDestroy')
	},
	destroyed () {
		console.log('destroyed')
		
		//this.inited = false
	}
}
